export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 max-w-5xl mx-auto bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl overflow-hidden">
          <div className="flex-1 p-8 md:p-12 lg:p-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-4">移动追剧更便捷</h2>
            <p className="text-sm md:text-base text-primary-100 leading-relaxed mb-6">
              58影院完美适配手机浏览器，无需下载APP，打开网页即可畅享高清追剧体验。支持iOS和Android全平台，随时随地想看就看。
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-background-50/15 backdrop-blur-sm border border-background-50/20 cursor-pointer hover:bg-background-50/25 transition-colors">
                <i className="ri-apple-line text-background-50 text-xl"></i>
                <div>
                  <p className="text-xs text-primary-100">iOS Safari</p>
                  <p className="text-sm font-semibold text-background-50">浏览器打开</p>
                </div>
              </div>
              <div className="flex items-center gap-3 px-5 py-3 rounded-lg bg-background-50/15 backdrop-blur-sm border border-background-50/20 cursor-pointer hover:bg-background-50/25 transition-colors">
                <i className="ri-android-line text-background-50 text-xl"></i>
                <div>
                  <p className="text-xs text-primary-100">Android Chrome</p>
                  <p className="text-sm font-semibold text-background-50">浏览器打开</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 p-6 md:p-0 lg:pr-10 flex justify-center">
            <div className="relative w-48 h-80 bg-background-950/30 rounded-3xl overflow-hidden border-2 border-background-50/20">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20TV%20drama%20streaming%20interface%20with%20drama%20poster%20thumbnails%20and%20play%20button%2C%20clean%20modern%20UI%20design%20with%20warm%20dark%20theme%2C%20minimal%20design%2C%20isolated%20on%20transparent%20background%2C%20app%20interface%20screenshot%20style&width=400&height=700&seq=app-phone-2026&orientation=portrait"
                alt="58影院移动端追剧界面"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}